import React, { useEffect } from 'react';
import { useApptekster } from '../../contexts/ApptekstContext';
import { useApi } from '../../hooks/useApi';
import {
    AktivSakStatus,
    DineSkiltSakStatus,
    hentBetalingsinfo,
    SakStatus,
} from '../../utils/api';
import { SVVSpinner } from '@komponentkassen/svv-spinner';
import { Paragraph } from '../../components/Paragraph';
import { SVVButton } from '@komponentkassen/svv-button';

type BetalSkiltStegProps = {
    sakStatus: SakStatus;
    soknadId: number;
};

export const BetalRettighetSteg: React.FC<BetalSkiltStegProps> = ({
    sakStatus,
    soknadId,
}) => {
    const t = useApptekster();
    const { hent, laster, data } = useApi(hentBetalingsinfo);

    useEffect(() => {
        if (data?.terminalUrlStandard) {
            window.location.href = data.terminalUrlStandard;
        }
    }, [data]);

    const visSpinner = laster || data;

    switch (sakStatus) {
        case AktivSakStatus.MOTTATT:
        case AktivSakStatus.UNDER_BEHANDLING:
            return (
                <li className="statusliste__steg">
                    <h3 className="svv-h5">
                        {t('personlig-kjennemerke.status.betal-skilt')}
                    </h3>
                </li>
            );
        case AktivSakStatus.INNVILGET:
            return (
                <li className="statusliste__steg aktiv">
                    <h3 className="svv-h5 svv-h5--spacing">
                        {t('personlig-kjennemerke.status.betal-skilt')}
                    </h3>
                    <Paragraph>
                        {t(
                            'personlig-kjennemerke.status.betal-skilt.ingress.del1',
                        )}
                    </Paragraph>
                    <Paragraph>
                        {t(
                            'personlig-kjennemerke.status.betal-skilt.ingress.del2',
                        )}
                    </Paragraph>

                    <div aria-live="polite">
                        {visSpinner && (
                            <SVVSpinner size="small" centered={false}>
                                {t('personlig-kjennemerke.delt.laster')}
                            </SVVSpinner>
                        )}
                    </div>
                    {!visSpinner && (
                        <SVVButton onClick={() => hent(soknadId)}>
                            {t('personlig-kjennemerke.status.betal-skilt')}
                        </SVVButton>
                    )}
                </li>
            );
        case AktivSakStatus.BETALT:
        case AktivSakStatus.SKILT_BESTILT:
        case AktivSakStatus.SKILT_BESTILT_BRUKER:
        case AktivSakStatus.SKILT_MOTTATT:
        case DineSkiltSakStatus.SKILT_UTLEVERT:
        case DineSkiltSakStatus.KNYTTET:
            return (
                <li className="statusliste__steg fullfort">
                    <h3 className="svv-h5 svv-h5--spacing">
                        {t('personlig-kjennemerke.status.betal-skilt.betalt')}
                    </h3>
                    <p>
                        {t(
                            'personlig-kjennemerke.status.betal-skilt.betalt.ingress',
                        )}
                    </p>
                </li>
            );
        default:
            return <></>;
    }
};
